import React from 'react'
import PageHeader from '../components/PageHeader'
import ContactForm from '../components/ContactForm'
import { COMPANY_INFO } from '../lib/constants'

export default function Kontakt() {
  return (
    <div className="space-y-16 pb-16">
      <PageHeader
        badge="Ring eller skriv"
        title="Kontakt jakobelektriker.dk"
        subtitle="Hurtigst kontakt opnås ved at ringe direkte til Jakob på 22 32 99 79. Du kan også udfylde kontaktformularen."
        breadcrumb="Kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Left Column: Company information & Call action */}
          <div className="lg:col-span-5 space-y-6">
            {/* Primary Phone Box */}
            <div className="relative bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-8 shadow-2xl border border-[#2D346E]/60 space-y-6 overflow-hidden">
              <div
                className="absolute top-0 right-0 w-48 h-48 bg-[#252A6E]/20 rounded-full blur-2xl pointer-events-none"
                aria-hidden="true"
              />
              <div className="relative z-10">
                <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#B5BBE8] mb-2 bg-[#252A6E]/50 border border-[#3C449E]/40 px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <span>Primær kontaktkanal</span>
                </span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight mt-2">
                  Ring direkte til Jakob
                </h2>
                <p className="text-[#9FA6D9] text-xs sm:text-sm mt-2 leading-relaxed">
                  Jakob foretrækker telefonisk kontakt. Det er den hurtigste måde at afklare opgavens omfang, give en cirka-pris eller aftale et tidspunkt.
                </p>
              </div>

              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="relative z-10 flex items-center justify-center gap-2.5 w-full rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3.5 shadow-md transition-all text-sm uppercase tracking-wider whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                <span>{COMPANY_INFO.phone}</span>
              </a>

              <div className="relative z-10 text-center text-xs text-[#9FA6D9]">
                Klikbart telefonnummer – ringer direkte op på mobil
              </div>
            </div>

            {/* Fuld virksomhedsinformation */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 shadow-sm space-y-6">
              <h3 className="text-lg font-bold text-slate-900 pb-3 border-b border-slate-100">
                Virksomhedsoplysninger
              </h3>

              <div className="space-y-4 text-sm text-slate-700">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="fa-solid fa-building" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-slate-500 block uppercase">Firmanavn</span>
                    <strong className="text-slate-900 text-base">{COMPANY_INFO.name}</strong>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-slate-500 block uppercase">Adresse</span>
                    <span className="text-slate-900 font-medium">
                      {COMPANY_INFO.address}<br />
                      {COMPANY_INFO.postal} {COMPANY_INFO.city}, {COMPANY_INFO.country}
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-slate-500 block uppercase">Telefon</span>
                    <a
                      href={`tel:${COMPANY_INFO.phoneRaw}`}
                      className="font-bold text-slate-900 hover:text-[#E36C0A] text-base whitespace-nowrap transition-colors"
                    >
                      {COMPANY_INFO.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="fa-regular fa-envelope text-xs" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-slate-500 block uppercase">E-mail</span>
                    <a
                      href={`mailto:${COMPANY_INFO.email}`}
                      className="font-medium text-slate-900 hover:text-[#E36C0A] text-sm whitespace-nowrap transition-colors"
                    >
                      {COMPANY_INFO.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="fa-solid fa-id-card" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-slate-500 block uppercase">CVR-nummer</span>
                    <span className="font-semibold text-slate-900">{COMPANY_INFO.cvr}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Interactive Form */}
          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  )
}
